<template>
  <div class="procedures-container">
    <ProceduresTabPage />
  </div>
</template>

<script>
import ProceduresTabPage from "@components/OrganizationProceduresTab/ProceduresTabPage.vue";
export default {
  components: {
    ProceduresTabPage,
  },
};
</script>

<style scoped>
.procedures-container {
  width: 100%;
}
</style>
